module.exports = __webpack_public_path__ + "static/ben-horowitz-9a9e54f0381dba0ad3f6258450a904ae.jpg";